module.exports = __webpack_public_path__ + "static/media/charley_wave_full.16179ff0.svg";